import { DivLiner } from '@/components/Common';
import { assets, images, paths } from '@/config';
import { externalPaths } from '@/config/paths';
import * as React from 'react';
import Media from 'react-media';
import { Link } from 'react-router-dom';
import { Header, Image } from 'semantic-ui-react';
import enhance from './enhancer';
import logoWhiteImage from './logo-white.png';

import './style.scss';

function Footer() {
  const applyNavigation = () => {
    return (
      <>
        <div className="c__contents">
          <Header className="contents">コンテンツ</Header>

          {!window.isAuthed ? (
            <React.Fragment />
          ) : (
            <div className="link sell">
              <Link to={paths.sell}>出品する</Link>
            </div>
          )}
          <div className="link fishes">
            <Link to={paths.fishes.all}>出品魚一覧</Link>
          </div>
          <div className="link">
            <Link to={paths.common.fee}>離島料金</Link>
          </div>
        </div>
        <div className="c__guide">
          <Header className="guide">ご利用ガイド</Header>
          <div className="link terms">
            <Link to={paths.introduction.explain}>Fish Saleについて</Link>
          </div>
          <div className="link terms">
            <Link to={paths.introduction.fee}>サービス利用料について</Link>
          </div>
          <div className="link terms">
            <Link to={paths.introduction.sell}>出品方法について</Link>
          </div>
          <div className="link terms">
            <Link to={paths.introduction.account}>口座登録方法について</Link>
          </div>
          <div className="link terms">
            <Link to={paths.introduction.change_sales_account}>
              口座・入金スケジュールの変更方法について
            </Link>
          </div>
          <div className="link terms">
            <Link to={paths.introduction.sales_account}>Stripeについて</Link>
          </div>
          <div className="link terms">
            <Link to={paths.introduction.howto_sales_account}>
              Stripeの登録方法について
            </Link>
          </div>
          <div className="link terms">
            <Link to={paths.introduction.cooking}>
              処理方法、食中毒について
            </Link>
          </div>
          <div className="link terms">
            <Link to={paths.introduction.banner}>バナー使用について</Link>
          </div>
          <div className="link terms">
            <Link to={paths.introduction.card}>セキュリティコードについて</Link>
          </div>
          <div className="link terms">
            <Link to={paths.introduction.styrofoam}>
              発泡スチロール購入先について
            </Link>
          </div>
          <div className="link terms">
            <Link to={paths.introduction.prepayment}>
              元払い出品の送料について
            </Link>
          </div>
        </div>

        <div className="c__aboutus">
          <Header className="aboutus">Fish Saleについて</Header>
          <div className="link">
            <a
              href={externalPaths.company}
              target="_blank"
              rel="noopener noreferrer"
            >
              会社概要
            </a>
          </div>
          <div className="link terms">
            <a
              href={externalPaths.terms}
              target="_blank"
              rel="noopener noreferrer"
            >
              ご利用規約
            </a>
          </div>
          <div className="link law">
            <a
              href={externalPaths.law}
              target="_blank"
              rel="noopener noreferrer"
            >
              特定商取引に関する表記
            </a>
          </div>
          <div className="link privacy">
            <a
              href={externalPaths.privacy}
              target="_blank"
              rel="noopener noreferrer"
            >
              プライバシーポリシー
            </a>
          </div>
          <div className="link company">
            <Link to={paths.common.contact}>お問い合わせ</Link>
          </div>
          <div className="link media_publication">
            <Link to={paths.common.mediaPublication}>メディア掲載</Link>
          </div>
          <div className="sns_lists flex">
            <a
              href="https://www.facebook.com/FishSale.JP/"
              rel="noopener noreferrer"
              target="_blank"
            >
              <Image src={assets.fish_facebook_icon} className="logo" />
            </a>
            <a
              href="https://www.instagram.com/fishsale_jp/"
              rel="noopener noreferrer"
              target="_blank"
            >
              <Image src={assets.fish_instagram_icon} className="logo" />
            </a>
          </div>
        </div>

        <div className="c__aboutus">
          <Header className="aboutus">グループサイト</Header>
          <div className="link">
            <a
              href="https://fruitsale.jp/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer--fruitsale__link"
            >
              <img src={logoWhiteImage} className="ui image" />
            </a>
          </div>
          <div className="link">
            <a
              href="https://meatsale.jp/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer--fruitsale__link"
            >
              <img
                src={'https://meatsale.jp/assets/logo/logo-white.png'}
                className="ui image"
              />
            </a>
          </div>
          <div className="link">
            <a
              href="https://vegetablesale.jp/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer--fruitsale__link"
            >
              <img
                src={'https://vegetablesale.jp/assets/logo/logo-white.png'}
                className="ui image"
              />
            </a>
          </div>
        </div>
      </>
    );
  };

  return (
    <footer className="app_footer">
      <div className="main flex">
        <div className="logo_inverted flex">
          <div className="flex">
            <Link to={paths.landing}>
              <Image src={images.logo_footer} />
            </Link>
          </div>
        </div>
        <DivLiner className="divider" />

        <Media
          query="(min-width: 768px)"
          render={() => (
            <div className="navigation grid">{applyNavigation()}</div>
          )}
        />
        <Media
          query="(max-width: 767px)"
          render={() => (
            <div className="navigation flex">{applyNavigation()}</div>
          )}
        />
      </div>

      <div className="copyright flex">
        <span>&copy;2019 Fish Sale</span>
      </div>
    </footer>
  );
}

export default enhance((props) => <Footer {...props} />);
